module.exports = __webpack_public_path__ + "img/3_8.9f7adcf3.png";